import {
  TABLE_CONTEXT_SUFFIX,
  TILE_CONTEXT_SUFFIX,
  TIME_SERIES_CONTEXT_SUFFIX,
  WIDGETS_CONTEXT_SUFFIX,
} from './constants/contexts';

export class ContextsService {
  static isTableContext(context?: string): boolean {
    return context ? context.includes(TABLE_CONTEXT_SUFFIX) : false;
  }

  static isTimeSeriesContext(context?: string): boolean {
    return context ? context.includes(TIME_SERIES_CONTEXT_SUFFIX) : false;
  }

  static isTilesContext(context?: string): boolean {
    return context ? context.includes(TILE_CONTEXT_SUFFIX) : false;
  }

  static isWidgetsContext(context?: string): boolean {
    return context ? context.includes(WIDGETS_CONTEXT_SUFFIX) : false;
  }

  isTableContext(context?: string): boolean {
    return ContextsService.isTableContext(context);
  }

  isTimeSeriesContext(context?: string): boolean {
    return ContextsService.isTimeSeriesContext(context);
  }

  isTilesContext(context?: string): boolean {
    return ContextsService.isTilesContext(context);
  }

  isWidgetsContext(context?: string): boolean {
    return ContextsService.isWidgetsContext(context);
  }

  isContextKey(key: string): boolean {
    const isTableContext = this.isTableContext(key);
    const isTimeSeriesContext = this.isTimeSeriesContext(key);
    const isTilesContext = this.isTilesContext(key);
    const isWidgetsContext = this.isWidgetsContext(key);
    return isTableContext || isTimeSeriesContext || isTilesContext || isWidgetsContext;
  }
}
